"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TruncatedText = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var text_1 = require("../text");
var truncate_middle_1 = require("./lib/truncate-middle");
function TruncatedText(_a) {
    var text = _a.text;
    var containerRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(null), truncatedText = _b[0], setTruncatedText = _b[1];
    (0, react_1.useEffect)(function () {
        if (containerRef.current) {
            var charWidth = 7;
            var stringLength = Math.ceil(containerRef.current.offsetWidth / charWidth);
            setTruncatedText((0, truncate_middle_1.truncateMiddle)(text, stringLength));
        }
    }, [containerRef]);
    return (react_1.default.createElement(StyledContainer, { ref: containerRef }, truncatedText && react_1.default.createElement(text_1.Text, { display: "inline" }, truncatedText)));
}
exports.TruncatedText = TruncatedText;
var StyledContainer = styled_components_1.default.span(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  display: block;\n  width: 100%;\n"], ["\n  display: block;\n  width: 100%;\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map